import styles from "./WWTabs.module.css";

import { randomUUID, getStringHash } from "../../axios_with_token";

export default function WWTabs({tabDefs, id:idIn, onTagClick}){
    const id=idIn||`tabs-${randomUUID()}`;
    return <>
        {/*  className="sticky-top" style={{top:"100px", background:"white"}} */}
        <nav>
            <div className="nav nav-tabs " id={id} role="tablist">
                {tabDefs.map(tabDef=>{
                    const tabName = getStringHash(tabDef.name||tabDef.caption); //tabDef.name||tabDef.caption;
                    return <button
                        key={`nav-${id}-${tabName}-tab`}
                        id={`nav-${id}-${tabName}-tab`}
                        role="tab"
                        className={["nav-link ", tabDef.active?'show active':''].join(' ')}
                        data-bs-toggle="tab"
                        data-bs-target={`#nav-${id}-${tabName}`}
                        type="button"
                        aria-controls={`nav-${id}-${tabName}`}
                        aria-selected={tabDef.active?"true":"false"}
                        onClick={(caption=>(evt=>onTagClick&&onTagClick({caption, evt})))(tabDef.caption)}
                    >
                        {tabDef.caption}
                    </button>
                })}
            </div>
        </nav>
        <div className="tab-content" id={`${id}-nav-tabContent`}>
            {tabDefs.map(tabDef=>{
                const tabName =  getStringHash(tabDef.name||tabDef.caption);
                const Content = tabDef.Content || (({})=><div className="m-3">
                    <div className="row mb-3">
                        no content
                    </div>
                </div>);
                return <div
                    key={`nav-${id}-${tabName}`}
                    id={`nav-${id}-${tabName}`}
                    role="tabpanel"
                    className={["tab-pane fade ", tabDef.active?'show active':''].join(' ')}
                    aria-labelledby={`nav-${id}-${tabName}-tab`}
                >
                    <Content></Content>
                </div>
            })}
        </div>
    </>;
}
